import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { CompanyGroup } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import Delete from '../Delete.vue';
    import EditCompanyGroup from './EditCompanyGroup.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';

    interface Props {
        companyGroup: CompanyGroup;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CompanyGroupTableActions',
  props: {
    companyGroup: {}
  },
  setup(__props: any) {

    

    const { hasPermission } = usePermissions();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTableActions, { data: _ctx.companyGroup }, {
    default: _withCtx(() => [
      (_unref(hasPermission)(_unref(Permission).COMPANIES_UPDATE))
        ? (_openBlock(), _createBlock(EditCompanyGroup, {
            key: 0,
            "company-group": _ctx.companyGroup
          }, null, 8, ["company-group"]))
        : _createCommentVNode("", true),
      (_unref(hasPermission)(_unref(Permission).COMPANIES_DELETE))
        ? (_openBlock(), _createBlock(Delete, {
            key: 1,
            route: _ctx.route('v2.company-groups.destroy', _ctx.companyGroup.id),
            "query-key": [_unref(QueryKey).COMPANY_GROUPS],
            "success-message": "company-groups.deleted",
            "error-message": "company-groups.delete.error"
          }, null, 8, ["route", "query-key"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})